/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetFileRenditionContentQueryResponse, FilesControllerGetFileRenditionContentPathParams } from "../../models/filesController/FilesControllerGetFileRenditionContent";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetFileRenditionContent } from "../../clients/filesService/filesControllerGetFileRenditionContent";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetFileRenditionContentQueryKey = (id: FilesControllerGetFileRenditionContentPathParams["id"], renditionId: FilesControllerGetFileRenditionContentPathParams["renditionId"]) => [{
  url: '/api/v1/files/:id/renditions/:renditionId/content',
  params: {
    id: id,
    renditionId: renditionId
  }
}] as const;
export type FilesControllerGetFileRenditionContentQueryKey = ReturnType<typeof filesControllerGetFileRenditionContentQueryKey>;
export function filesControllerGetFileRenditionContentQueryOptions(id: FilesControllerGetFileRenditionContentPathParams["id"], renditionId: FilesControllerGetFileRenditionContentPathParams["renditionId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetFileRenditionContentQueryKey(id, renditionId);
  return queryOptions<FilesControllerGetFileRenditionContentQueryResponse, ResponseErrorConfig<Error>, FilesControllerGetFileRenditionContentQueryResponse, typeof queryKey>({
    enabled: !!(id && renditionId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetFileRenditionContent(id, renditionId, config);
    }
  });
}

/**
 * @description Returns the content of a file rendition, proxied through the API to avoid CORS issues.
 * @summary Get file rendition content
 * {@link /api/v1/files/:id/renditions/:renditionId/content}
 */
export function useFilesControllerGetFileRenditionContent<TData = FilesControllerGetFileRenditionContentQueryResponse, TQueryData = FilesControllerGetFileRenditionContentQueryResponse, TQueryKey extends QueryKey = FilesControllerGetFileRenditionContentQueryKey>(id: FilesControllerGetFileRenditionContentPathParams["id"], renditionId: FilesControllerGetFileRenditionContentPathParams["renditionId"], options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetFileRenditionContentQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetFileRenditionContentQueryKey(id, renditionId);
  const query = useQuery({
    ...filesControllerGetFileRenditionContentQueryOptions(id, renditionId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}